export default "__VITE_ASSET__1bd671fe__"